import * as React from "react";
import { IconType } from "../../../gfx/svgsprite-imports";

export interface IconPolyfillProps {
  icon: IconType;
}

const DOM_ELEMENT_ID = "svg-poly-target";

export default class IconPolyfill extends React.Component<IconPolyfillProps> {
  constructor(props: IconPolyfillProps) {
    super(props);
  }

  fetchIcon(url, callback: (response: any) => void) {
    let request = new XMLHttpRequest();
    let response;
    request.open("GET", url, true);

    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        response = request.responseText;
        callback.call(this, response);
      } else {
        console.log("Error reaching the server");
      }
    };
    request.onerror = function () {
      console.log("Connection error");
    };
    request.send();
  }

  createDomElement(): HTMLElement {
    const htmlStr = `<div id="${DOM_ELEMENT_ID}" style="position: absolute;height: 0; width: 0;"></div>`;
    let frag = document.createDocumentFragment();
    let temp = document.createElement("div");

    temp.innerHTML = htmlStr;

    while (temp.firstChild) {
      frag.appendChild(temp.firstChild);
    }
    document.body.insertBefore(frag, document.body.childNodes[0]);
    return document.getElementById(DOM_ELEMENT_ID);
  }

  public render() {
    return null;
  }
}
